
import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Home.css";
import { esvSections } from "./esvSections";
import { Link } from "react-router-dom";

function Home() {
  return (
    <div className="page-bg">
      <header className="header">
        <h1 className="display-4">ESV - Bludenz</h1>
        <p className="lead">Eisenbahnersportverein – Sektions Übersicht</p>
      </header>

      <main className="container my-5">
        <div className="row justify-content-center">
        {esvSections.map((section, idx) => (
  <div className="col-12 mb-4" key={idx}>
    {section.link.startsWith("http") ? (
      <a
        href={section.link}
        target="_blank"
        rel="noopener noreferrer"
        className="btn btn-outline-dark btn-lg w-100 d-flex align-items-center shadow-sm section-button"
      >
        <img
          src={`${process.env.PUBLIC_URL}/${section.icon}`}
          alt={`${section.name} Icon`}
          className="section-icon"
        />
        <span>{section.name}</span>
      </a>
    ) : (
      <Link
        to={section.link}
        className="btn btn-outline-dark btn-lg w-100 d-flex align-items-center shadow-sm section-button"
      >
        <img
          src={`${process.env.PUBLIC_URL}/${section.icon}`}
          alt={`${section.name} Icon`}
          className="section-icon"
        />
        <span>{section.name}</span>
      </Link>
    )}
  </div>
))}
        </div>
      </main>

      <footer className="footer">
        © {new Date().getFullYear()} ESV Bludenz – Eine Linksammlung zu allen ESV-Bludenz Sektionen <Link to="/impressum">Impressum</Link>
      </footer>
    </div>
  );
}

export default Home;
